/**
 * This is the main entry point for modals in the application.
 * We use a centralized ModalController class to manage all modal operations.
 */

// Import and export from the controller file
import { ModalController, type ModalProps, type ModalHandler } from './ModalController';
export { ModalController, type ModalProps, type ModalHandler };
// Re-export the Provider for backward compatibility
export const ModalProvider = ModalController.Provider;
